import React from 'react'
import '../Style/Por_Takhfif.css'
import RightArrowIcon from '../Logos/chevron-right-arrow (1).svg'
import LeftArrowIcon from '../Logos/chevron-left-arrow.svg'


function Por_Offer_Com() {
    return (
        <>
            <div className='lots-of-offer-container'>
                <div className='title'>محصولات پر تخفیف</div>
                <div className='products-container'>
                    <div className='arrow-left-button'>
                        <img src={LeftArrowIcon} />
                    </div>
                    <div className='products-slider'>
                        <div className='product'>
                            <div className='product-image' style={{ backgroundImage: `url(${require("../Product_Images/516823.jpg")})` }}></div>
                            <div className='offer-percent'>85%</div>
                            <div className='offered-price'>
                                <i class="icony icony-toman"></i>
                                <div className='price'>10,000</div>
                            </div>
                        </div>
                        <div className='product'>
                            <div className='product-image' style={{ backgroundImage: `url(${require("../Product_Images/1b3d620e25ecfeccfe946d335e499386125f10aa.jpeg")})` }}></div>
                            <div className='offer-percent'>55%</div>
                            <div className='offered-price'>
                                <i class="icony icony-toman"></i>
                                <div className='price'>10,000</div>
                            </div>
                        </div>
                        <div className='product'>
                            <div className='product-image' style={{ backgroundImage: `url(${require("../Product_Images/904db77cea07619877a4ee9f26a0fba96215615d_1602397201.jpg")})` }}></div>
                            <div className='offer-percent'>91%</div>
                            <div className='offered-price'>
                                <i class="icony icony-toman"></i>
                                <div className='price'>10,000</div>
                            </div>
                        </div>
                        <div className='product'>
                            <div className='product-image' style={{ backgroundImage: `url(${require("../Product_Images/1426030.jpg")})` }}></div>
                            <div className='offer-percent'>65%</div>
                            <div className='offered-price'>
                                <i class="icony icony-toman"></i>
                                <div className='price'>10,000</div>
                            </div>
                        </div>
                        <div className='product'>
                            <div className='product-image' style={{ backgroundImage: `url(${require("../Product_Images/2.jpg")})` }}></div>
                            <div className='offer-percent'>59%</div>
                            <div className='offered-price'>
                                <i class="icony icony-toman"></i>
                                <div className='price'>10,000</div>
                            </div>
                        </div>
                        <div className='product'>
                            <div className='product-image' style={{ backgroundImage: `url(${require("../Product_Images/هواکش-صنعتی-دمنده-30-سانت-1400-دور-مدل-ایلکای-هفت-پر-با-قاب-vik-30l4s.jpg")})` }}></div>
                            <div className='offer-percent'>85%</div>
                            <div className='offered-price'>
                                <i class="icony icony-toman"></i>
                                <div className='price'>10,000</div>
                            </div>
                        </div>
                        <div className='product'>
                            <div className='product-image' style={{ backgroundImage: `url(${require("../Product_Images/1694.jpg")})` }}></div>
                            <div className='offer-percent'>85%</div>
                            <div className='offered-price'>
                                <i class="icony icony-toman"></i>
                                <div className='price'>10,000</div>
                            </div>
                        </div>
                    </div>
                    <div className='arrow-right-button'>
                        <img src={RightArrowIcon} />
                    </div>
                </div>
            </div>
        </>
    )
}

export default Por_Offer_Com